import { MuiAlert } from '@fox/atoms/src/mui-alert/index';
import { IBlockDefinition, IBlockProps } from '@fox/blocks/contracts/block';
import { Padded } from '@fox/layout/src/style';
import { SECTION_BLOCK_TYPE } from '../../../form-block-types';
import { QuestionStyleTypes } from '../../form-runtime-context/contracts';
import { useFormRuntimeContext, useQuestionStyle } from '../../form-runtime-context/form-runtime-context';
import { RenderBlockComponent } from '../../render-block-component';
import { SectionBlockProps } from './contracts';
import { SectionWrapper } from './section-wrapper';

export function SectionBlock({ props, lastPage }: IBlockProps<SectionBlockProps> & { lastPage?: boolean }) {
	const { backgroundColour } = useQuestionStyle(QuestionStyleTypes.general, {});
	const { currentPage, sections } = useFormRuntimeContext();
	if (!props.innerLayout?.layouts?.length) {
		return <MuiAlert severity="error">Section has no inner layout!</MuiAlert>;
	}

	const myPage = sections.findIndex(c => c.branchId === props.branchId);
	if (!lastPage && myPage !== currentPage) {
		return <></>;
	}

	return (
		<SectionWrapper $inPreview={true} $backgroundColour={backgroundColour}>
			<Padded>
				{props.innerLayout.layouts.map(layout => {
					return <RenderBlockComponent {...layout} key={layout.id} />;
				})}
			</Padded>
		</SectionWrapper>
	);
}

export const SectionBlockRunTime: IBlockDefinition<SectionBlockProps> = {
	type: SECTION_BLOCK_TYPE,
	Component: SectionBlock
};
